module.exports = __webpack_public_path__ + "img/4.bed0acd2.png";